const nebulaBrainDailyTradeModalRegistry = {};
export default nebulaBrainDailyTradeModalRegistry;
